// У учасника команди є лише прапорець «показувати на сайті», тому статуси
// «Опубліковано / Чернетка / Архівовано» тут ніколи ні з чим не збігались.
export const TEAM_FILTERS = [
  {
    key: 'status',
    type: 'checkbox',
    label: 'Видимість',
    options: [
      { value: 'active', label: 'Показані на сайті' },
      { value: 'inactive', label: 'Приховані' },
    ],
  },
];

export const useTeamFilters = () => TEAM_FILTERS;
